/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {DomainWeb} from './DomainWeb';

/**
 * The Domain model module.
 * @module model/Domain
 * @version 1.0.0
 */
export class Domain {
  /**
   * Constructs a new <code>Domain</code>.
   * @alias module:model/Domain
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Domain</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Domain} obj Optional instance to populate.
   * @return {module:model/Domain} The populated <code>Domain</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Domain();
      if (data.hasOwnProperty('web'))
        obj.web = DomainWeb.constructFromObject(data['web']);
      if (data.hasOwnProperty('mail'))
        obj.mail = DomainWeb.constructFromObject(data['mail']);
    }
    return obj;
  }
}

/**
 * @member {module:model/DomainWeb} web
 */
Domain.prototype.web = undefined;

/**
 * @member {module:model/DomainWeb} mail
 */
Domain.prototype.mail = undefined;

